import { useQuery } from '@apollo/client';
import { Mutation } from '@apollo/client/react/components';
import React from 'react';
import { EDIT_USER } from '../../../queries/user';
import { CREATE_ACCESS, GET_USER_ACCESS } from '../../../queries/userAccess';
import Form from '../components/form';

const Update = (props) => {
  // eslint-disable-next-line react/destructuring-assignment
  const { data, loading } = useQuery(GET_USER_ACCESS, { variables: { user: props.id, siteActive: true } });

  return (
    <>
      <Mutation mutation={EDIT_USER}>
        {updateUser => (
          <Mutation mutation={CREATE_ACCESS} update={() => {}}>
            {createAccess => (
              loading ? <></> : (
                <Form
                  query_f={updateUser}
                  query_access={createAccess}
                  sites={data.accesses.map((userAccess) => {
                    return userAccess.site.id;
                  })}
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...props}
                />
              )
            )}
          </Mutation>
        )}
      </Mutation>
    </>
  );
};

export default Update;
